import { convertObjectToParams } from "../../components/commons/commons";
import http from "./helpers/httpInterceptor";
import {
  DATE_FORMAT_V2_DMY_HM,
  formatDateStringToString,
  getInfoStaff,
} from "@/utils";

const state = () => ({
  Request: [],
  requestList: [],
  dataRequestUpdated: [],
  dataStatusUpdated: [],
  dataAssignee: {},
  dateDateApprovedTimeSheet: {},
  dataRequestSelections: [],
  dataDurationTime: {},
  dataBatchRequest: {},
  reasonTypeList: [],
  historyData: [],
});

// mutations
const mutations = {
  REQUEST(states, data) {
    states.Request = data;
  },
  REQUEST_DATA_LIST(states, data) {
    states.requestList = data;
  },
  UPDATE_REQUEST(states, data) {
    states.dataRequestUpdated = data;
  },
  UPDATE_REQUEST_STATUS(states, data) {
    states.dataStatusUpdated = data;
  },
  UPDATE_REQUEST_ASSIGNEE_DATA(states, data) {
    states.dataAssignee = data;
  },
  CHECK_DATE_APPROVED_TIEMSHEET(states, data) {
    states.dateDateApprovedTimeSheet = data;
  },
  REQUEST_SELECTIONS(states, data) {
    states.dataRequestSelections = data;
  },
  GET_DURATION_TIME(states, data) {
    states.dataDurationTime = data;
  },
  BATCH_REQUEST(states, data) {
    states.dataBatchRequest = data;
  },
  SET_REASON_TYPE_LIST(state, data) {
    state.reasonTypeList = data;
  },
  HISTORY_DATA(states, data) {
    states.historyData = formatHistory(data);
  },
};

// actions
const actions = {
  getRequestData({ commit }, url) {
    return http
      .get("/tms/request-management" + url)
      .then((res) => {
        commit("REQUEST_DATA_LIST", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getParamsDataToSelect({ commit }, payload) {
    return http
      .get(`/tms/request-management/create-request-selections${convertObjectToParams(payload)}`)
      .then((res) => {
        commit("REQUEST_SELECTIONS", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  createRequest({ commit }, payload) {
    return http
      .post("/tms/request-management/create-request/", payload)
      .then((res) => {
        commit("REQUEST", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  createRequestFlexible({ commit }, payload) {
    return http
      .post("/tms/request-management/create-request-flexible/", payload)
      .then((res) => {
        commit("REQUEST", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  createBatchRequest({ commit }, payload) {
    return http
      .post("/tms/request-management/batch-create-request/", payload)
      .then((res) => {
        commit("BATCH_REQUEST", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  updateRequestDelegate({ commit }, payload) {
    return http
      .put(`/tms/request-management/update-assignee`, payload)
      .then((res) => {
        commit("UPDATE_REQUEST_ASSIGNEE_DATA", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  updateRequest({ commit }, payload) {
    return http
      .put("/tms/request-management/edit-request", payload)
      .then((res) => {
        commit("UPDATE_REQUEST", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  updateRequestFlexible({ commit }, payload) {
    return http
      .put("/tms/request-management/edit-request-flexible", payload)
      .then((res) => {
        commit("UPDATE_REQUEST", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  updateStatusRequest({ commit }, payload) {
    return http
      .put("/tms/request-management/update-status", payload)
      .then((res) => {
        commit("UPDATE_REQUEST_STATUS", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  checkDateWithinApprovedTimesheet({ commit }, params) {
    return http
      .get(`tms/timesheets/is-date-from-approved-timesheet?date=${params}`)
      .then((res) => {
        commit("CHECK_DATE_APPROVED_TIEMSHEET", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },

  getDurationTime({ commit }, payload) {
    return http
      .post("/tms/request-management/time-and-duration", payload)
      .then((res) => {
        commit("GET_DURATION_TIME", res.data.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  createCommonRequest(_, payload) {
    return http
      .post("/tms/request-management/create-common-request", payload)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  editCommonRequest(_, payload) {
    return http
      .put("/tms/request-management/edit-common-request", payload)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getReasonTypeList({ commit }) {
    return http
      .get(`tms/request-management/create-request-selections-v2`)
      .then((res) => {
        commit("SET_REASON_TYPE_LIST", res.data.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getHistoryData({ commit }, payload) {
    return http
      .get(`/tms/request-management/on-site-history${convertObjectToParams(payload)}`)
      .then((res) => {
        commit("HISTORY_DATA", res.data.data);
        return res.data;
      })
      .catch((error) => {
        commit("HISTORY_DATA", []);
        throw error;
      });
  },
};

export const formatHistory = (data) => {
  if (!data || data.length <= 0) return [];
  return data?.map((item) => {
    const { new_record, createdDate, action } = item;
    return {
      ...item,
      createdDateFormat: formatDateStringToString(createdDate, DATE_FORMAT_V2_DMY_HM),
      new_record: {
        ...new_record,
        createdByName: `${new_record?.createdBy?.name ?? ""} - ${new_record?.createdBy?.departmentName ?? ""}`,
        createdDateFormat: formatDateStringToString(new_record?.createdDate, DATE_FORMAT_V2_DMY_HM),
        updatedBy: `${new_record?.modifiedBy?.name ?? ""} - ${new_record?.modifiedBy?.departmentName ?? ""}`,
        modifiedDateFormat: formatDateStringToString(new_record?.modifiedDate, DATE_FORMAT_V2_DMY_HM),
        fullName: getInfoStaff(new_record?.employee),
        projectName: new_record?.project?.projectName ?? "",
        applyDateFormat: formatDateStringToString(new_record?.applyDate),
        expireDateFormat: formatDateStringToString(new_record?.expireDate),
        action,
      },
    };
  });
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
